<template>
  <div class="container">
    <!--<div class="explain_grid">
      <h1Letter letter="19"></h1Letter>
      <h1Letter letter="20"></h1Letter>
      <h1Letter letter="15"></h1Letter>
      <h1Letter letter="14"></h1Letter>
      <h1Letter letter="5"></h1Letter>

      <h1Letter :hide="true" letter="1s"></h1Letter>
      <h1Letter :hide="true" letter="1t"></h1Letter>
      <h1Letter :hide="true" letter="1o"></h1Letter>
      <h1Letter :hide="true" letter="1n"></h1Letter>
      <h1Letter :hide="true" letter="1e"></h1Letter>
    </div>-->
    <div @click="ganjalf = false" style="width: 100%; font-size: 80px">
      <h1 class="title" style="display: flex; justify-content: space-between">
        <span>192015145</span> <span>stone</span>
      </h1>
    </div>
    <div style="width: 100%">
      <SLink
        :id="index"
        :key="link.link"
        :link="link.link"
        :name="link.name"
        :image="link.image"
        :target="link.target || '_blank'"
        @click.native="link.onclick ? ganjalf = !ganjalf : null"
        v-for="(link, index) in links"
      />
    </div>
  </div>
</template>
<script>
import SLink from "@/components/Link";
export default {
  components: {
    SLink,
  },
  data() {
    return {
      ganjalf: false,
      links: [
        {
          image:
            "/gandalf.png",
          name: ":O - : يا",
          link:
            "#/gandalf",
            target: "_self",
        },
        {
          image:
            "https://d1fdloi71mui9q.cloudfront.net/NXq6LKeR4oeq4OLAaO9g_clown-face_1f921.png",
          name: "Portfolio - محفظة التصميم",
          link:
            "#/portfolio",
            target: "_self",
        },
        {
          image:
            "/x.jpeg",
          name: "X - تويتر",
          link: "https://twitter.com/st_____one",
        },
        {
          image:
            "https://d1fdloi71mui9q.cloudfront.net/7wg5asluR2mqeee8nNZA_pushpin_1f4cc.png",
          name: "IG - الانستغرام",
          link: "https://www.instagram.com/st___one",
        },

        {
          image:
            "/lobster.jpeg",
          name: "FTBL - اتبع اللوبستر الأزرق",
          link: "https://followthebluelobster.com",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.title {
  font-size: min(10vw, 15px);
  margin: 0px;
  font-weight: 100;
  text-decoration: none;
    color: white;
    cursor: pointer;
  span {
    text-decoration: none;
    color: white;
  }
}
h1 {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 24px;
  font-style: normal;
  font-variant: normal;
  font-weight: 700;
  line-height: 26.4px;
}
h3 {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 14px;
  font-style: normal;
  font-variant: normal;
  font-weight: 700;
  line-height: 15.4px;
}
p,
a {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 14px;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  line-height: 20px;
}
blockquote {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 21px;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  line-height: 30px;
}
pre {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 13px;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  line-height: 18.5714px;
}
body {
  color: white;
  font-family: sans-serif;
  background-color: black;
}

.logo {
  width: 200px;
  margin-bottom: 20px;
}

.explain_grid {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(5, 1fr);
}
.container {
  height: 100dvh;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  margin: auto;
}
</style>
